/**
 * Parse Handelsregister native payload from company.organizationData.
 * Strips account-level credits_remaining if present.
 */
export function parseHandelsregisterOrganizationData(company) {
    if (!company) {
        return null;
    }

    const raw = company.organizationData ?? company.organization_data;
    if (!raw) {
        return null;
    }

    try {
        const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!data || typeof data !== 'object') {
            return null;
        }

        if (data.meta && typeof data.meta === 'object') {
            const { credits_remaining, ...metaRest } = data.meta;
            return {
                ...data,
                meta: metaRest
            };
        }

        return data;
    } catch (e) {
        return null;
    }
}

export function hasNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

export function hasNonEmptyObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0;
}

export function formatMoney(amount, currency = 'EUR') {
    if (amount === null || amount === undefined || amount === '') {
        return '-';
    }
    const num = Number(amount);
    if (Number.isNaN(num)) {
        return String(amount);
    }
    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency || 'EUR',
            maximumFractionDigits: 0
        }).format(num);
    } catch (e) {
        return `${num} ${currency || ''}`.trim();
    }
}

export function formatAddress(address) {
    if (!address) {
        return '-';
    }
    if (typeof address === 'string') {
        return address;
    }
    const line = [address.street, address.house_number].filter(Boolean).join(' ');
    const cityLine = [address.postal_code, address.city].filter(Boolean).join(' ');
    return [line, cityLine, address.state, address.country].filter(Boolean).join(', ') || '-';
}

export function formatRole(person) {
    return (
        person?.role?.en?.long ||
        person?.role?.de?.long ||
        person?.label ||
        '-'
    );
}
